var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0995 3.84001C16.6382 3.30155 17.3687 2.99913 18.1303 2.99927C18.8919 2.99941 19.6223 3.3021 20.1608 3.84075C20.6992 4.37941 21.0016 5.1099 21.0015 5.87154C21.0014 6.63317 20.6987 7.36355 20.16 7.90201L19.0605 9.00001L14.997 4.941L16.098 3.84001H16.0995ZM13.9395 6.0015L5.00551 14.9325C4.73433 15.2039 4.52995 15.5346 4.40851 15.8985L3.03751 20.013C2.99371 20.145 2.98749 20.2866 3.01955 20.422C3.0516 20.5573 3.12067 20.6811 3.21903 20.7795C3.31739 20.8778 3.44116 20.9469 3.57652 20.979C3.71188 21.011 3.85348 21.0048 3.98551 20.961L8.10001 19.59C8.46451 19.47 8.79451 19.2645 9.06601 18.993L18 10.062L13.938 6.0015H13.9395Z",
    fill: "#027A77"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil_icon.57918febb6c8844c1f681cabb2693c63.svg";
export { ForwardRef as ReactComponent };